/**
 * Cart upsells (subscription / selling plan). One card at a time.
 * Next upsell is always derived from cart contents (Liquid JSON), not sessionStorage.
 * Clicks: capture-phase delegation (drawer uses @click.stop).
 */
(function () {
  try {
    sessionStorage.removeItem("cartUpsellSeq");
  } catch (e) {}

  function el(sel, root) {
    return (root || document).querySelector(sel);
  }

  function parseJson(scriptSel, root) {
    var s = el(scriptSel, root);
    if (!s || !s.textContent) return [];
    try {
      return JSON.parse(s.textContent.trim());
    } catch (e) {
      return [];
    }
  }

  function getCartProductIds(root) {
    return parseJson("[data-cart-product-ids]", root);
  }

  function cartHasProduct(ids, productId) {
    var n = Number(productId);
    for (var i = 0; i < ids.length; i++) {
      if (Number(ids[i]) === n) return true;
    }
    return false;
  }

  /**
   * Next offer = first slot in config order whose product is not in the cart.
   * Liquid only emits slots that are still addable; this matches after AJAX refresh.
   */
  function nextUpsellEntry(config, cartIds) {
    for (var i = 0; i < config.length; i++) {
      if (!cartHasProduct(cartIds, config[i].productId)) {
        return config[i];
      }
    }
    return null;
  }

  function fetchCfg() {
    if (typeof fetchConfigDefaults === "function") {
      return fetchConfigDefaults("application/javascript");
    }
    return {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/javascript",
      },
    };
  }

  function escapeHtml(str) {
    if (str == null || str === "") return "";
    var d = document.createElement("div");
    d.textContent = str;
    return d.innerHTML;
  }

  function formatUpsellMoney(cents) {
    if (
      typeof formatMoney === "function" &&
      window.theme &&
      window.theme.moneyFormat
    ) {
      return formatMoney(cents, theme.moneyFormat);
    }
    return cents != null ? String(cents) : "";
  }

  /** Fetch section HTML and fire shapes:cart:update (same payload CartItems expects). */
  function refreshCartSectionsFromPage() {
    var path =
      typeof window.location.pathname === "string"
        ? window.location.pathname
        : "/";
    var sep = path.indexOf("?") >= 0 ? "&" : "?";
    var url =
      path +
      sep +
      "sections=cart-items,cart-footer,cart-item-count,cart-live-region";

    return fetch(url, { credentials: "same-origin" })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (out) {
        if (!out.ok || !out.data || typeof out.data !== "object") return;
        var data = out.data;
        if (data.status) {
          return;
        }
        document.dispatchEvent(
          new CustomEvent("shapes:cart:update", {
            bubbles: true,
            detail: {
              response: {
                sections: data,
              },
            },
          })
        );
      })
      .catch(function (e) {
        console.error("Cart upsell: refresh sections failed", e);
      });
  }

  function cardHtml(u, btnWrapClass) {
    var vid = String(u.variantId);
    var sid = String(u.sellingPlanId);
    var imgBlock = u.image
      ? '<img src="' +
        escapeHtml(u.image) +
        '" alt="" class="media__styled-element h-14 w-14 shrink-0 object-cover md:h-20 md:w-20" width="80" height="80" sizes="(min-width: 48em) 5rem, 3.5rem" loading="lazy">'
      : '<div class="flex h-14 w-14 shrink-0 items-center justify-center rounded-[var(--media-border-radius)] border border-dashed border-scheme-text/20 bg-scheme-secondary-background text-scheme-text md:h-20 md:w-20" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none" class="h-6 w-6 text-current md:h-8 md:w-8" aria-hidden="true"><path d="M6.44969 11.5868C6.41273 11.8335 6.22793 12 6 12C5.77207 12 5.58727 11.8335 5.55031 11.5868C4.98357 7.48612 4.44148 6.98047 0.431212 6.45015C0.178645 6.42549 0 6.24049 0 6C0 5.75951 0.178645 5.57451 0.431212 5.54368C4.44148 5.10586 5.02053 4.52004 5.55031 0.406989C5.58727 0.16033 5.77207 0 6 0C6.22793 0 6.41273 0.16033 6.44969 0.406989C6.97947 4.52004 7.55852 5.10586 11.5688 5.54368C11.8214 5.57451 12 5.75951 12 6C12 6.24049 11.8214 6.42549 11.5688 6.45015C7.55852 6.89414 6.97947 7.47996 6.44969 11.5868Z" fill="currentColor"/></svg></div>';
    var priceUnderTitle = "";
    if (u.subscriptionPrice != null && u.subscriptionPrice !== "") {
      var sp = Number(u.subscriptionPrice);
      if (!Number.isNaN(sp)) {
        var cp =
          u.compareAtPrice != null && u.compareAtPrice !== ""
            ? Number(u.compareAtPrice)
            : NaN;
        var main = formatUpsellMoney(sp);
        if (!Number.isNaN(cp) && cp > sp) {
          priceUnderTitle =
            '<div class="mt-1 flex flex-col gap-0.5 tabular-nums">' +
            '<s class="text-xs leading-none text-scheme-text/45">' +
            formatUpsellMoney(cp) +
            "</s>" +
            '<span class="text-sm leading-tight lg:text-base text-scheme-text">' +
            main +
            "</span>" +
            "</div>";
        } else {
          priceUnderTitle =
            '<p class="mt-1 text-sm leading-tight lg:text-base tabular-nums text-scheme-text">' +
            main +
            "</p>";
        }
      }
    }
    var middleBlock =
      '<div class="min-h-0 min-w-0 flex-1 overflow-hidden">' +
      '<p class="truncate text-sm leading-tight lg:text-base text-scheme-text">' +
      escapeHtml(u.title) +
      "</p>" +
      priceUnderTitle +
      "</div>";
    return (
      '<article class="rounded-[var(--card-border-radius)] border-general border-scheme-text bg-scheme-background p-3 sm:p-4">' +
      '<div class="flex min-w-0 flex-row flex-nowrap items-center gap-2.5 sm:gap-3">' +
      '<a href="' +
      escapeHtml(u.url) +
      '" class="shrink-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-scheme-text">' +
      imgBlock +
      "</a>" +
      middleBlock +
      '<div class="' +
      escapeHtml(
        ["shrink-0", "self-center", (btnWrapClass || "").trim()]
          .filter(function (c) {
            return c;
          })
          .join(" ")
      ) +
      '">' +
      '<button type="button" data-cart-upsell-add data-variant-id="' +
      escapeHtml(vid) +
      '" data-selling-plan-id="' +
      escapeHtml(sid) +
      '" class="push-btn cursor-pointer whitespace-nowrap disabled:cursor-not-allowed disabled:opacity-45">' +
      '<span class="push-btn__surface px-3.5 py-2 text-xs font-medium">' +
      escapeHtml(u.addLabel) +
      "</span>" +
      "</button>" +
      "</div>" +
      "</div>" +
      "</article>"
    );
  }

  /** Drawer + /cart page: same card everywhere; wrap classes from Liquid (button shadow padding). */
  function initUpsells() {
    var wraps = document.querySelectorAll("[data-cart-upsells]");
    if (!wraps.length) return;

    var first = wraps[0];
    var config = parseJson("[data-cart-upsells-json]", first);
    var cartIds = getCartProductIds(first);
    var btnWrapClass = (first.getAttribute("data-btn-wrap-class") || "").trim();

    function hideAll() {
      wraps.forEach(function (wrap) {
        wrap.hidden = true;
        var m = el("[data-cart-upsells-mount]", wrap);
        if (m) m.innerHTML = "";
      });
    }

    if (!config.length) {
      hideAll();
      return;
    }

    var u = nextUpsellEntry(config, cartIds);
    if (!u) {
      hideAll();
      return;
    }

    var html = cardHtml(u, btnWrapClass);
    wraps.forEach(function (wrap) {
      var mount = el("[data-cart-upsells-mount]", wrap);
      if (!mount) return;
      wrap.hidden = false;
      mount.innerHTML = html;
    });
  }

  function addUpsell(btn, variantId, sellingPlanId) {
    if (!window.theme || !window.theme.routes || !window.theme.routes.cart_add_url) {
      console.error("Cart upsell: theme.routes.cart_add_url missing");
      return;
    }

    btn.disabled = true;
    var formData = new FormData();
    formData.append("id", String(variantId));
    formData.append("quantity", "1");
    formData.append("selling_plan", String(sellingPlanId));

    if (
      window.theme.settings &&
      window.theme.settings.cartType === "modal"
    ) {
      formData.append(
        "sections",
        "cart-items,cart-footer,cart-item-count,cart-live-region"
      );
      formData.append("sections_url", window.location.pathname);
    }

    var cfg = fetchCfg();
    cfg.body = formData;
    delete cfg.headers["Content-Type"];

    fetch(window.theme.routes.cart_add_url, cfg)
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (out) {
        var data = out.data;
        if (!out.ok || data.status) {
          btn.disabled = false;
          var msg =
            (data && (data.description || data.message)) ||
            (window.theme.strings && window.theme.strings.cartError) ||
            "Could not add to cart.";
          alert(msg);
          scheduleInit();
          return;
        }
        refreshCartSectionsFromPage()
          .catch(function () {})
          .finally(function () {
            scheduleInit();
          });
      })
      .catch(function (err) {
        btn.disabled = false;
        console.error(err);
        scheduleInit();
      });
  }

  function scheduleInit() {
    requestAnimationFrame(function () {
      initUpsells();
    });
  }

  /**
   * Capture phase: clicks inside the cart drawer never bubble to `document` because
   * `#right-drawer-slot` uses `@click.stop` (see snippets/right-drawer.liquid).
   * Bubble-phase delegation therefore never runs for ADD.
   */
  document.addEventListener(
    "click",
    function (e) {
      var btn = e.target.closest("[data-cart-upsell-add]");
      if (!btn || btn.disabled) return;
      var wrap = btn.closest("[data-cart-upsells]");
      if (!wrap) return;
      var vid = btn.getAttribute("data-variant-id");
      var sid = btn.getAttribute("data-selling-plan-id");
      if (!vid || !sid) return;
      e.preventDefault();
      addUpsell(btn, vid, sid);
    },
    true
  );

  document.addEventListener("DOMContentLoaded", scheduleInit);
  document.addEventListener("theme:product:add", scheduleInit);
  document.addEventListener("theme:cart:change", scheduleInit);
  document.addEventListener("theme:cart:update", scheduleInit);
  document.addEventListener("shopify:section:load", scheduleInit);
})();
